/* eslint-disable autofix/no-unused-vars */

export enum AlertStatus {
    MarkAttended = 0,
    Attended = 1,
}

export const alertStatusEnum = {
    0: "Mark Attended",
    1: "Attended",
};

export enum AlertType {
    Delay = 1,
}

export interface Alerts {
    id: string;
    branchCode: string;
    branchName: string;
    alertType: number;
    alertDescription: string;
    alertTime: string;
    status: number;
    licenseeId: string;
}

export enum AlertSortDirection {
    Ascending = 0,
    Descending = 1,
}
